import { createPlanNameMatcher } from './utils/PlanMetaHelper';
import { IPlanContent } from '../typings/planContent.types';
import {
  byoBatteryAddon,
  defaultEstimatesDialog,
  businessDualKeyDetailsAddons,
  businessElectricityKeyDetailsAddons,
  defaultBusinessGasDetailsAddons,
  ongoingBenefitPeriodKeyDetails,
} from './common/planDefaults';
import { createSolarInfoContent } from './common/solarInfoContent';

const PLAN_TONE = 'caution';

export const originBusinessGoSolarVariableContent: IPlanContent = {
  test: createPlanNameMatcher(['Origin Business Go Solar Variable']),
  content: {
    rateDiscountText: {
      defaultState: {
        defaultFuel: 'Rates variable on an ongoing benefit period',
      },
    },
    keyFeatures: {
      defaultState: {
        defaultFuel: ['No lock in contract or exit fees'],
      },
    },
    keyDetails: {
      defaultState: {
        defaultFuel: ongoingBenefitPeriodKeyDetails,
      },
    },
    keyDetailsAddons: {
      defaultState: {
        defaultFuel: [],
        dual: [...businessDualKeyDetailsAddons, byoBatteryAddon],
        gas: defaultBusinessGasDetailsAddons,
        electricity: [...businessElectricityKeyDetailsAddons, byoBatteryAddon],
      },
    },
    uiOptions: {
      defaultState: {
        defaultFuel: {
          planColor: {
            text: {
              styleGuide: 'grey',
              odsCore: 'neutral',
            },
            promobox: {
              styleGuide: 'lightOrange',
              odsCore: PLAN_TONE,
            },
            bannerText: {
              styleGuide: 'grey56',
              odsCore: 'neutralDark',
            },
          },
          imageUrl:
            'https://res.cloudinary.com/originenergy/image/upload/v1728625552/spot-illustrations/spot_solar.svg',
          imageForFuelType: {
            electricity:
              'https://www.originenergy.com.au/cdn/images/originenergy/image/upload/CP/plans/cp_origin-business-go-solar-variable_elec.svg',
            dual: 'https://www.originenergy.com.au/cdn/images/originenergy/image/upload/CP/plans/cp_origin-business-go-solar-variable_dual.svg',
          },
        },
      },
    },
    tagLine: {
      defaultState: {
        defaultFuel: 'A higher than standard feed-in tariff, on an ongoing energy plan.',
      },
    },
    termsAndConditionsUrl: {
      defaultState: {
        defaultFuel: '/terms-and-conditions-origin-business-go-solar-variable/',
      },
    },
    estimatesDialog: defaultEstimatesDialog({ customerType: 'business' }),
    solarInfo: {
      defaultState: {
        defaultFuel: {
          title: 'Origin Business Go Solar Variable',
          content: createSolarInfoContent('Origin Business Go Solar Variable', true),
        },
      },
    },
  },
};
